// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

export default {
    init() {
        // console.log('MIASTO INIT');

        // Homepage MOBILE DIETS SLIDER
        const dietsMobile = new Swiper("#diets-mobile", {
          effect: "coverflow",
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 3,
          loop: true,
          speed: 800,
          autoplay: {
            delay: 3500,
            disableOnInteraction: false,
          },
          initialSlide: 1,
          coverflowEffect: {
            rotate: 1,
            stretch: -80,
            depth: 500,
            modifier: 1,
            slideShadows: false,
          },
          // hidden navigation
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });

  },
}